<div class="card-body my-auto">
  <ng-container *ngIf="noNotes">
    <h6 class="card-title">There are no notes for this client yet</h6>
  </ng-container>

  <app-loading [busy]="loadingNotes"></app-loading>

  <ng-container *ngIf="!noNotes">
    <table class="table table-sm" mdbTable hover="true">
      <thead>
        <tr>
          <th>
            <span class="md-form col-6">
              <input
                [(ngModel)]="searchText"
                mdbInput
                name="searchText"
                type="search"
                id="searchText"
                placeholder="Search"
                style="font-size: small; border-bottom-color: #7b7f82"
              />
            </span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let note of clientNotes | filterNote: searchText">
          <tr
            [ngClass]="{
              'update-success': note.recentlyUpdated,
              'note-milestone': note.noteTypeDescription == 'Milestone',
              'note-admin': note.noteTypeDescription == 'Admin'
            }"
          >
            <td class="text-muted small" style="min-width: 115px">
              <span>{{ note.dateTimeCreated | date: "dd MMM yyyy HH:mm" }} | {{ note.createdByUserFullName }}</span>
            </td>
            <td class="text-muted small">
              <mdb-icon *ngIf="note.noteTypeDescription == 'Milestone'" fas icon="crown" class="mr-1"></mdb-icon>
              <mdb-icon *ngIf="note.noteTypeDescription == 'Admin'" fas icon="user-edit" class="mr-1"></mdb-icon>
              {{ note.note }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-container>
</div>
